import React, { useEffect, useState } from "react";
import styles from "../../../../../styles/pages/user/content-buyer-messagedetails.module.scss";
import {
    Box,
    Button,
    Grid,
    List,
    ListItem,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import BackArrow from "../../../../../ui/Icons/BackArrow";
import message_blog_image from "../../../../../public/assets/images/messagedetails_inner.jpg";
import { Link, useNavigate, useParams } from "react-router-dom";
import UploadIcon from "../../../../../ui/Icons/Upload";
import PerfectScrollbar from "react-perfect-scrollbar";
import people from "../../../../../public/assets/images/people.svg";
import UploadPin from "../../../../../ui/Icons/UploadPin";
import DownArrowBlue from "../../../../../ui/Icons/DownArrowBlue";
import { useRef } from "react";
import UserWrapper from "../../../../../layout/userwrapper/UserWrapper";
import AddPlusIcon from "../../../../../public/assets/icons/AddPlusIcon";
import TrashIcon from "../../../../../public/assets/icons/TrashIcon";
import BtnCrossIcon from "../../../../../public/assets/icons/BtnCrossIcon";
import useFetch from "../../../../../hooks/api/useFetch";

const fileUploadContent = [
    {
        status: true,
        name: "5028537_5563370603774986_243130120555181753_n.jpg",
    },
    {
        status: false,
        name: "5028537_5563370603774986.png",
    },
    {
        status: false,
        name: "5028537_5563370603774986_2431301205551817se_522gfjgdstAjdfdfgfvc556254dz52df52sdfd53_n.jpg",
    },
];

const viralSnareUpload = [
    {
        name: "Theodore Doulke",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: true,
        desgnationname: "Manager",
        paragraph: (
            <>
                Hi Maxime, <br />
                How are you doing today? <br />
                Sure, please reset your password through the following link:
                viralsnare.com/pwd_reset. <br />
                Don’t hesitate to reach back if you needed anything else! <br />
                Kind regards,
            </>
        ),
        attachedfile: false,
        attachedfilename: "",
    },
    {
        name: "Me, Myself & I",
        image: `${people}`,
        date: "September 14, 2022 at 08:56 AM UTC",
        desgnation: true,
        desgnationname: "Partner",
        paragraph: (
            <>
                Hi there, <br /> I hope all is well with you! <br />I am trying
                to reset my password but it’s not letting me do it. Can you help
                me with this? <br />
                Thank you!
            </>
        ),
        attachedfile: true,
        attachedfilename: "5028537_5563370603774986.png",
    },
    {
        name: "ViralSnare Agent",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: false,
        desgnationname: "",
        paragraph: (
            <>
                Hi Maxime, <br />
                How are you doing today? <br />
                Sure, please reset your password through the following link:
                viralsnare.com/pwd_reset. <br />
                Don’t hesitate to reach back if you needed anything else! <br />
                Kind regards,
            </>
        ),
        attachedfile: false,
        attachedfilename: "",
    },
    {
        name: "John Martin",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: true,
        desgnationname: "Editor",
        paragraph: (
            <>
                Hi there, <br /> I hope all is well with you! <br />I am trying
                to reset my password but it’s not letting me do it. Can you help
                me with this? <br />
                Thank you!
            </>
        ),
        attachedfile: true,
        attachedfilename: "5028537_5563370603774986.png",
    },
    {
        name: "ViralSnare Agent",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: false,
        desgnationname: "",
        paragraph: (
            <>
                Hi Maxime, <br />
                How are you doing today? <br />
                Sure, please reset your password through the following link:
                viralsnare.com/pwd_reset. <br />
                Don’t hesitate to reach back if you needed anything else! <br />
                Kind regards,
            </>
        ),
        attachedfile: false,
        attachedfilename: "",
    },
];

const ContentBuyerMessage = () => {
    const { id } = useParams();
    const [message, setMessage] = useState(undefined);
    const [messageStatus, setMessageStatus] = useState({ name: "", class: "" });
    const [respondToInquiry, setRespondToInquiry] = useState(false);
    const handleRespondToInquiry = () => {
        setRespondToInquiry((prev) => !prev);
    };
    const handleDownload = (fileLink) => {
        window.open(getAbsoluteDownloadURI(fileLink), "_blank");
    };
    const {
        data: messageData,
        isError: messageDataisError,
        isLoading: messageDataisLoading,
        isSuccess: messageDataisSuccess,
        refetch: messageDatarefetch,
    } = useFetch("message-detail", `inquiry/${id}`);
    const updateInquiry = async (params) => {
        const { data } = await axiosInstance.post("update-inquery", {
            ...params,
            inquery_id: message?.id,
        });
        messageDatarefetch();
        return data;
    };
    const resolveInquiry = () => {
        updateInquiry({
            status: 1,
        });
    };
    const openInquiry = () => {
        updateInquiry({
            status: 0,
        });
    };
    const archiveInquiry = () => {
        updateInquiry({
            archive: 1,
        });
    };
    const router = useNavigate();
    const goBack = () => {
        router(
            message?.video
                ? "/manager-dashboard/messages"
                : "/manager-dashboard/support"
        );
    };
    const [sendButton, sendUpdateButton] = React.useState(false);

    const submitSendHandler = () => {
        sendUpdateButton(!sendButton);
    };

    const fileInput = useRef(null);

    const handleClick = () => {
        fileInput.current.children[0].children[0].click();
    };
    const getStatus = (inquiry) => {
        if (!inquiry?.status) {
            if (
                inquiry?.initiated?.name === inquiry?.last_message?.sender?.name
            )
                return {
                    name: "Need your reply",
                    class: `${styles.statusTxt} ${styles.noNeed}`,
                };
            return {
                name: "Pending",
                class: `${styles.statusTxt} ${styles.pending}`,
            };
        }
        return {
            name: "Resolved",
            class: `${styles.statusTxt} ${styles.btngrnResolve}`,
        };
    };
    const {
        data: messagesForInquiry,
        isError: messagesForInquiryisError,
        isLoading: messagesForInquiryisLoading,
        isSuccess: messagesForInquiryisSuccess,
        refetch: messagesForInquiryrefetch,
    } = useFetch(
        ["inquiry-meassages", messageData?.data?.data?.id],
        `inquiry/${messageData?.data?.data?.id}/messages
        `
    );
    useEffect(() => {
        setMessage(messageData?.data?.data);
        setMessageStatus(getStatus(messageData?.data?.data));
    }, [messageData]);
    return (
        <UserWrapper headerPurchaseBtn={true} footerChatBtn={false}>
            <Box className={styles.messagedetails}>
                <Box className={styles.messagedetails_top}>
                    <Typography variant="h4" className={styles.cmn_h4}>
                        Message Details
                    </Typography>
                    <Button className={styles.back_btn_sec}>
                        <i>
                            <BackArrow />
                        </i>{" "}
                        Back
                    </Button>
                </Box>

                <Box className={styles.messagedetails_btms}>
                    <PerfectScrollbar className={styles.scrolls_container}>
                        <Box className={styles.message_details_outers}>
                            <Box className={styles.message_details_outers_lf}>
                                <Box className={styles.jumped_umbrella_outer}>
                                    <Box className={styles.figure_main}>
                                        <img src={message_blog_image} alt="" />
                                    </Box>
                                    <Box
                                        className={styles.jumped_umbrella_btms}
                                    >
                                        <Box
                                            className={styles.more_details_top}
                                        >
                                            <Typography
                                                variant="h5"
                                                className={styles.cmn_h5}
                                            >
                                                <Link to="/">
                                                    Boy Jumped with the Umbrella
                                                    and the Wind Almost Sent Him
                                                    Flying Too Far Away
                                                </Link>
                                            </Typography>
                                            <Box className={styles.vsid_detais}>
                                                <Box
                                                    className={
                                                        styles.vsid_detais_lft
                                                    }
                                                >
                                                    <Button
                                                        className={
                                                            styles.vsid_span
                                                        }
                                                    >
                                                        VSID:{" "}
                                                        <Typography variant="caption">
                                                            #156785
                                                        </Typography>
                                                    </Button>
                                                </Box>
                                                <Box
                                                    className={
                                                        styles.vsid_detais_rtt
                                                    }
                                                >
                                                    <Button
                                                        className={
                                                            styles.more_details_btn
                                                        }
                                                    >
                                                        More details
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>

                                        <Box
                                            className={styles.more_details_btms}
                                        >
                                            <Typography
                                                variant="h5"
                                                className={styles.creation_date}
                                            >
                                                Created on:
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                className={styles.creation_time}
                                            >
                                                January 14, 2023 at 8:36 PM UTC
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box className={styles.file_uld_options_outr}>
                                    <Box
                                        className={
                                            styles.file_uld_options_inner
                                        }
                                    >
                                        <h5 className={styles.option_h5}>
                                            Attached Files
                                        </h5>
                                        <Box
                                            className={styles.file_uploader_all}
                                        >
                                            <PerfectScrollbar
                                                className={
                                                    styles.perfectscrollinfo
                                                }
                                            >
                                                {fileUploadContent.map(
                                                    (item, index) => (
                                                        <Button
                                                            className={
                                                                item?.status
                                                                    ? `${styles.file_uploader_all_inner} ${styles.active}`
                                                                    : `${styles.file_uploader_all_inner}`
                                                            }
                                                        >
                                                            <i>
                                                                <UploadIcon />
                                                            </i>
                                                            <Box
                                                                className={
                                                                    styles.rt_contents
                                                                }
                                                            >
                                                                {item?.name}
                                                            </Box>
                                                        </Button>
                                                    )
                                                )}
                                            </PerfectScrollbar>
                                        </Box>
                                        {/* ================================= */}
                                        {/* ============ NO FILE ============ */}
                                        {/* ================================= */}
                                        {/* <Paper
                                                className={`${styles.styledPaper} ${styles.noAttachFile}`}
                                            >
                                                <img
                                                    src={IconNofile}
                                                    alt="icon"
                                                />
                                                <Typography variant="caption">
                                                    All files that will be uploaded will be displayed in
                                                    this section
                                                </Typography>
                                            </Paper> */}
                                    </Box>

                                    <Box
                                        className={
                                            styles.file_uld_options_inner
                                        }
                                    >
                                        <Box
                                            className={styles.initiate_msg_div}
                                        >
                                            <Typography variant="body1">
                                                <strong>Me, Myself & I</strong>{" "}
                                                <Typography
                                                    variant="caption"
                                                    className={
                                                        styles.editor_spn
                                                    }
                                                >
                                                    (Content Buyer)
                                                </Typography>{" "}
                                                initiated this message.
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box
                                        className={
                                            styles.file_uld_options_inner
                                        }
                                    >
                                        <Box
                                            className={
                                                styles.status_message_field
                                            }
                                        >
                                            <Box
                                                className={
                                                    styles.status_message_field_top
                                                }
                                            >
                                                <Typography
                                                    variant="caption"
                                                    className={
                                                        styles.status_text
                                                    }
                                                >
                                                    Status:
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    className={`${styles.status_valuesec} ${styles.pendingstat}`}
                                                >
                                                    Pending
                                                </Typography>
                                            </Box>

                                            <Box
                                                className={
                                                    styles.status_message_field_btm
                                                }
                                            >
                                                <List>
                                                    <ListItem>
                                                        <Button
                                                            className={
                                                                styles.black_btns
                                                            }
                                                        >
                                                            Respond
                                                        </Button>
                                                    </ListItem>

                                                    <ListItem>
                                                        <Button
                                                            className={
                                                                styles.gryy_btns
                                                            }
                                                        >
                                                            Mark as resolved
                                                        </Button>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Box className={styles.message_details_outers_rt}>
                                <Box className={styles.message_fileout_div}>
                                    {sendButton ? (
                                        <Box
                                            className={styles.respond_div_marks}
                                        >
                                            <Box
                                                className={
                                                    styles.respond_div_marks_outer
                                                }
                                            >
                                                <List>
                                                    <ListItem>
                                                        <Button
                                                            className={
                                                                styles.respond_btnss
                                                            }
                                                        >
                                                            Respond
                                                        </Button>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Button
                                                            className={
                                                                styles.respond_unread_btn
                                                            }
                                                        >
                                                            Mark as resolved
                                                        </Button>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box
                                            className={
                                                styles.file_attached_textar
                                            }
                                        >
                                            <Box
                                                className={
                                                    styles.file_attached_textar_top
                                                }
                                            >
                                                <Box
                                                    className={
                                                        styles.dated_file_attached
                                                    }
                                                >
                                                    <Box
                                                        className={
                                                            styles.dated_file_attached_lft
                                                        }
                                                    >
                                                        <Box
                                                            className={
                                                                styles.editor_profile_parent
                                                            }
                                                        >
                                                            <Box
                                                                className={
                                                                    styles.editor_profile_parent_lft
                                                                }
                                                            >
                                                                <img
                                                                    src={people}
                                                                    alt=""
                                                                />
                                                            </Box>
                                                            <Box
                                                                className={
                                                                    styles.editor_profile_parent_rtt
                                                                }
                                                            >
                                                                <Typography
                                                                    variant="h5"
                                                                    className={
                                                                        styles.cmn_h5
                                                                    }
                                                                >
                                                                    John Martin
                                                                </Typography>
                                                                <Typography
                                                                    variant="caption"
                                                                    className={
                                                                        styles.dsgntns
                                                                    }
                                                                >
                                                                    (Editor)
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>

                                                    <Box
                                                        className={
                                                            styles.dated_file_attached_rtt
                                                        }
                                                    >
                                                        <Typography
                                                            variant="caption"
                                                            className={
                                                                styles.date_spn_main
                                                            }
                                                        >
                                                            September 15, 2022
                                                            at 04:37 PM UTC
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>

                                            <Box
                                                className={
                                                    styles.file_attached_textar_mdl
                                                }
                                            >
                                                <form>
                                                    <Box
                                                        className={
                                                            styles.input_box_textarea
                                                        }
                                                    >
                                                        <TextField
                                                            multiline
                                                            rows={4}
                                                        />
                                                    </Box>
                                                    <Box
                                                        className={
                                                            styles.formInner
                                                        }
                                                    >
                                                        <Box
                                                            className={
                                                                styles.attach_frm_messages
                                                            }
                                                        >
                                                            <Box
                                                                className={
                                                                    styles.input_boxfile_attach
                                                                }
                                                            >
                                                                <Box
                                                                    className={
                                                                        styles.input_boxfile_outer
                                                                    }
                                                                >
                                                                    <Typography variant="caption">
                                                                        <i>
                                                                            <UploadPin />
                                                                        </i>{" "}
                                                                        Attach a
                                                                        file
                                                                    </Typography>
                                                                </Box>
                                                                <TextField
                                                                    type="file"
                                                                    className={
                                                                        styles.file_uploaders
                                                                    }
                                                                />
                                                            </Box>
                                                        </Box>
                                                        <Box
                                                            className={
                                                                styles.attach_frm_messages
                                                            }
                                                        >
                                                            <Stack
                                                                direction={
                                                                    "row"
                                                                }
                                                                alignItems={
                                                                    "center"
                                                                }
                                                                className={
                                                                    styles.showAddFile
                                                                }
                                                            >
                                                                <Button>
                                                                    <TrashIcon />
                                                                </Button>
                                                                <span>
                                                                    screenshot.png
                                                                </span>
                                                            </Stack>
                                                        </Box>
                                                        <Box
                                                            className={
                                                                styles.attach_frm_messages
                                                            }
                                                        >
                                                            <Stack
                                                                direction={
                                                                    "row"
                                                                }
                                                                alignItems={
                                                                    "center"
                                                                }
                                                                className={
                                                                    styles.showAddFile
                                                                }
                                                            >
                                                                <Button>
                                                                    <TrashIcon />
                                                                </Button>
                                                                <span>
                                                                    325007798_724967765618154_1330143271608700845_n.png
                                                                </span>
                                                            </Stack>
                                                            <Button
                                                                className={
                                                                    styles.btnAddBlack
                                                                }
                                                            >
                                                                <AddPlusIcon />
                                                            </Button>
                                                        </Box>
                                                        <Box
                                                            className={
                                                                styles.attach_frm_messages
                                                            }
                                                        >
                                                            <Box
                                                                className={
                                                                    styles.input_boxfile_attach
                                                                }
                                                            >
                                                                <Box
                                                                    className={`${styles.input_boxfile_outer} ${styles.input_selectFile}`}
                                                                >
                                                                    <Typography variant="caption">
                                                                        <i>
                                                                            <UploadPin />
                                                                        </i>{" "}
                                                                        Select
                                                                        file
                                                                    </Typography>
                                                                </Box>
                                                                <TextField
                                                                    type="file"
                                                                    className={
                                                                        styles.file_uploaders
                                                                    }
                                                                />
                                                            </Box>
                                                            <Button
                                                                className={`${styles.btnAddBlack} ${styles.roundBtn}`}
                                                            >
                                                                <BtnCrossIcon />
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                    <Box
                                                        className={
                                                            styles.btm_option_submitted
                                                        }
                                                    >
                                                        <Button
                                                            className={
                                                                styles.cancel_btns_pt
                                                            }
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            className={
                                                                styles.submitted_btn_ps
                                                            }
                                                            onClick={
                                                                submitSendHandler
                                                            }
                                                        >
                                                            Send{" "}
                                                            <Typography variant="caption">
                                                                {" "}
                                                                now
                                                            </Typography>
                                                        </Button>
                                                    </Box>
                                                </form>
                                            </Box>
                                        </Box>
                                    )}

                                    <Box
                                        className={
                                            styles.agent_share_fileattchd
                                        }
                                    >
                                        <Box
                                            className={
                                                styles.agent_share_fileattchd_outer
                                            }
                                        >
                                            {viralSnareUpload.map(
                                                (item, index) => (
                                                    <Box
                                                        className={
                                                            styles.agent_share_inners
                                                        }
                                                        key={index}
                                                    >
                                                        <Box
                                                            className={
                                                                styles.agent_share_inners_top
                                                            }
                                                        >
                                                            <Box
                                                                className={
                                                                    styles.share_agents_lft
                                                                }
                                                            >
                                                                <Box
                                                                    className={
                                                                        styles.agent_info_fgr_Wrap
                                                                    }
                                                                >
                                                                    <Box
                                                                        className={
                                                                            styles.agent_info_fgr_Wrap_img
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                item?.image
                                                                            }
                                                                            alt=""
                                                                        />
                                                                    </Box>

                                                                    <Box
                                                                        className={
                                                                            styles.agent_info_fgr_Wrap_content
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            variant="h5"
                                                                            className={
                                                                                styles.cmn_h5
                                                                            }
                                                                        >
                                                                            {
                                                                                item?.name
                                                                            }
                                                                        </Typography>
                                                                        {item?.desgnation && (
                                                                            <Typography
                                                                                variant="caption"
                                                                                className={
                                                                                    styles.desg_inner
                                                                                }
                                                                            >
                                                                                (
                                                                                {
                                                                                    item?.desgnationname
                                                                                }
                                                                                )
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                </Box>
                                                            </Box>

                                                            <Box
                                                                className={
                                                                    styles.share_agents_rtt
                                                                }
                                                            >
                                                                <Typography
                                                                    variant="caption"
                                                                    className={
                                                                        styles.agent_date
                                                                    }
                                                                >
                                                                    {item?.date}{" "}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        <Box
                                                            className={
                                                                styles.agent_share_inners_btm
                                                            }
                                                        >
                                                            <Box
                                                                className={
                                                                    styles.description_box
                                                                }
                                                            >
                                                                <Typography variant="body1">
                                                                    {
                                                                        item?.paragraph
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                            {item?.attachedfile && (
                                                                <Box
                                                                    className={
                                                                        styles.description_attached_boxes
                                                                    }
                                                                >
                                                                    <Typography
                                                                        variant="h5"
                                                                        className={
                                                                            styles.cmn_h5
                                                                        }
                                                                    >
                                                                        Attached
                                                                        files:
                                                                    </Typography>
                                                                    <Button
                                                                        className={
                                                                            styles.button_pdf_styled
                                                                        }
                                                                    >
                                                                        <i>
                                                                            <DownArrowBlue />
                                                                        </i>
                                                                        {
                                                                            item?.attachedfilename
                                                                        }
                                                                    </Button>
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                )
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </PerfectScrollbar>
                </Box>
            </Box>
        </UserWrapper>
    );
};

export default ContentBuyerMessage;
